KCVS.Views.UserReportInvolvedEmployeeRowTable =
  template: JST['user_report_rows/involved_employee_rows_table']()

  mounted: ->
    @fetchInvolvedEmployeeRows()

  data: ->
    rows: []

  methods:
    fetchInvolvedEmployeeRows: ->
      $.ajax
        url: "/project_partners/#{@.$root.projectPartnerId}/involved_employee_rows.json"
        method: 'GET'
        dataType: 'JSON'
        success: (data) =>
          @rows = data
